import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { applyBrand } from "../lib/brand";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [state, setState] = useState({ status: "loading", meta: null });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/meta");
      applyBrand(data.branding);
      setState({ status: "authed", meta: data });
    } catch (e) {
      setState({ status: "anon", meta: null });
    }
  }, []);

  useEffect(() => {
    load();
    const h = () => setState({ status: "anon", meta: null });
    window.addEventListener("bims:logout", h);
    return () => window.removeEventListener("bims:logout", h);
  }, [load]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setState({ status: "anon", meta: null });
  };

  return <Ctx.Provider value={{ ...state, reload: load, logout }}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);

export function useModule(key) {
  const { meta } = useApp();
  return meta?.modules.find((m) => m.key === key) || null;
}
